var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("title", [_vm._v("460553F9-550E-4484-BD59-F0F187BFA3F5@3x")]),
      _vm._v(" "),
      _c("desc", [_vm._v("Created with sketchtool.")]),
      _vm._v(" "),
      _c("defs"),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "WeLearn-Arbitrage-Step5-Part-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            transform: "translate(-744.000000, -764.000000)"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Card-1",
                transform: "translate(514.000000, 313.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Infos",
                    transform: "translate(198.000000, 418.000000)"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "icn-infos",
                        transform: "translate(32.000000, 33.000000)"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          id: "Rectangle-6",
                          fill: "#00B9FF",
                          x: "0",
                          y: "0",
                          width: "40",
                          height: "40",
                          rx: "4"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          id: "Combined-Shape",
                          d:
                            "M11,12.9950893 C11,11.8932319 11.8926228,11 12.9950893,11 L27.0049107,11 C28.1067681,11 29,11.8926228 29,12.9950893 L29,27.0049107 C29,28.1067681 28.1073772,29 27.0049107,29 L12.9950893,29 C11.8932319,29 11,28.1073772 11,27.0049107 L11,12.9950893 Z M21.8740234,24.0224609 C21.7965491,24.0589195 21.6712248,24.101074 21.4980469,24.1489258 C21.3248689,24.1967776 21.1699226,24.2207031 21.0332031,24.2207031 C20.741535,24.2207031 20.5364589,24.172852 20.4179688,24.0771484 C20.2994786,23.9814448 20.2402344,23.8014336 20.2402344,23.5371094 C20.2402344,23.4322911 20.2584634,23.2773448 20.2949219,23.0722656 C20.3313804,22.8671865 20.3723956,22.6848966 20.4179688,22.5253906 L20.9785156,20.5361328 C21.0332034,20.3538402 21.0708007,20.1533214 21.0913086,19.9345703 C21.1118165,19.7158192 21.1220703,19.5631515 21.1220703,19.4765625 C21.1220703,19.0572896 20.9750991,18.7166354 20.6811523,18.4545898 C20.3872056,18.1925443 19.9690782,18.0615234 19.4267578,18.0615234 C19.1259751,18.0615234 18.8069678,18.1150711 18.4697266,18.222168 C18.1324853,18.3292649 17.7792987,18.4580071 17.4101562,18.6083984 L17.2597656,19.2236328 C17.3691412,19.182617 17.500162,19.1393231 17.652832,19.09375 C17.8055021,19.0481769 17.9547519,19.0253906 18.1005859,19.0253906 C18.3968114,19.0253906 18.5973302,19.0755203 18.7021484,19.1757812 C18.8069667,19.2760422 18.859375,19.4537748 18.859375,19.7089844 C18.859375,19.8502611 18.8422853,20.0063468 18.8081055,20.1772461 C18.7739256,20.3481454 18.7317711,20.5292959 18.6816406,20.7207031 L18.1210938,22.7167969 C18.0709633,22.9264333 18.0345053,23.1144197 18.0117188,23.2807617 C17.9889322,23.4471037 17.9775391,23.6100252 17.9775391,23.7695312 C17.9775391,24.1796896 18.1290675,24.5180651 18.4321289,24.784668 C18.7351903,25.0512709 19.1601535,25.1845703 19.7070312,25.1845703 C20.0625018,25.1845703 20.3746731,25.1378585 20.6435547,25.0444336 C20.9124362,24.9510086 21.2724587,24.8154306 21.7236328,24.6376953 L21.8740234,24.0224609 Z M22.0175781,15.6757812 C22.0175781,15.3294254 21.8865573,15.0332044 21.6245117,14.7871094 C21.3624661,14.5410144 21.0468768,14.4179688 20.6777344,14.4179688 C20.3085919,14.4179688 19.9918633,14.5410144 19.7275391,14.7871094 C19.4632148,15.0332044 19.3310547,15.3294254 19.3310547,15.6757812 C19.3310547,16.0221371 19.4632148,16.3172188 19.7275391,16.5610352 C19.9918633,16.8048515 20.3085919,16.9267578 20.6777344,16.9267578 C21.0468768,16.9267578 21.3624661,16.8048515 21.6245117,16.5610352 C21.8865573,16.3172188 22.0175781,16.0221371 22.0175781,15.6757812 Z",
                          fill: "#FFFFFF"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }